import { NavbarLink } from './interface';

import { IconCurrencyPound, IconDashboard, IconUsers } from '@tabler/icons-react';

export const adminNavbarLinks: NavbarLink[] = [
  {
    link: '/',
    label: 'dashboard',
    icon: IconDashboard
  },
  {
    link: '/users',
    label: 'users',
    icon: IconUsers
  },
  {
    link: '/price_plans',
    label: 'price_plans',
    icon: IconCurrencyPound
  }
];
